import { render, staticRenderFns } from "./MediaRightAlign.vue?vue&type=template&id=71e752fa&"
import script from "./MediaRightAlign.vue?vue&type=script&lang=js&"
export * from "./MediaRightAlign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports